import { useEffect } from "react";
import { useAIModelStore, Category } from "../store/aiModelStore";

// Re-export Category type for backward compatibility
export type { Category };

/**
 * Hook to access AI models and categories
 * Uses centralized Zustand store with caching to prevent duplicate API calls
 */
export default function useAIModels() {
  const { categories, models, loading, error, fetchCategories } =
    useAIModelStore();

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { models, categories, loading, error };
}
